var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"talentTitle"},[_c('div',{staticClass:"mainTitle"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_vm._t("subTitle")],2),_vm._v(" "),_vm._t("btn")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-778b5dcd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/talentServices/talentTitle.vue
// module id = null
// module chunks = 